interface StateDesc {
  미사용: string;
  사용완료: string;
  기사용오류: string;
  유효기간오류: string;
  판매등록: string;
  판매중지: string;
  판매시작: string;
  판매종료: string;
  [key: string]: string;
}

interface RefundStateDesc {
  환불요청: string;
  환불완료: string;
  '환불 완료'?: string;
  [key: string]: string | undefined;
}

export interface Translations {
  home: string;
  receivedGifts: string;
  sentGifts: string;
  /** 마켓 헤더 — 받은 선물함·구매내역 통합 메뉴(→ /received) */
  integratedGiftBox: string;
  /** [APP-FORK] 앱 전용 상점정보 탭/화면 */
  storeInfo: string;
  storeInfoBasicTitle: string;
  storeInfoContactTitle: string;
  storeInfoNaverMap: string;
  storeInfoKakaoMap: string;
  storeInfoInstagram: string;
  storeInfoEmpty: string;
  orderDatePrefix: string;
  orderDetailLink: string;
  orderStoreNameLabel: string;
  orderRecipientLabel: string;
  orderRecipientSelf: string;
  orderRecipientPending: string;
  orderRecipientReceived: string;
  orderStatusComplete: string;
  orderStatusPurchaseFail: string;
  orderStatusPurchasePending: string;
  orderStatusReprocess: string;
  orderRecvUnreceived: string;
  orderRecvReceived: string;
  giftVersionLabel: string;
  giftSerialNoLabel: string;
  giftStatus: string;
  giftVerification: string;
  sendGift: string;
  selfGift: string;
  inStock: string;
  remainingStock: string;
  giftTargetSelf: string;
  giftTargetFriend: string;
  giftTargetReceived: string;
  roulettePrizeBadge: string;
  roulettePrizeSentTitle: string;
  roulettePrizeSentGuide: string;
  roulettePrizeSentDelivered: string;
  roulettePrizeRefundGuide: string;
  roulettePrizeReceivedTitle: string;
  roulettePrizeReceivedGuide: string;
  validityPeriodDate: string;
  validityPeriod: (months: number) => string;
  paymentCondition: (hours: number) => string;
  refundCondition: string;
  giftSerial: string;
  state: string;
  usageState: string;
  refundState: string;
  giftStateLabel: string;
  extendValidityAction: string;
  extendValidityLoading: string;
  giftNotPurchasable: string;
  giftAmountLabel: string;
  paymentInfoTitle: string;
  totalDiscountLabel: string;
  paidAmountLabel: string;
  discountAppliedSuffix: string;
  paymentMethodTitle: string;
  extendValidityConfirm: string;
  extendValiditySuccess: string;
  extendValidityFailed: string;
  requestReprocess: string;
  requestReprocessLoading: string;
  requestReprocessConfirm: string;
  requestReprocessSuccess: string;
  requestReprocessFailed: string;
  requestReprocessAlready: string;
  sender: string;
  senderPhone: string;
  senderEmail: string;
  giftMessage: string;
  unused: string;
  unavailable: string;
  all: string;
  sendGiftAction: string;
  copyGiftLink: string;
  sendGiftLinkInstruction: string;
  makePayment: string;
  giftSuccess: string;
  checkSentGift: string;
  recipientPhone: string;
  recipientEmail: string;
  giftNote: string;
  within50Chars: string;
  giftReceiveLink: string;
  copyLink: string;
  giftQr: string;
  printAllUsageQr: string;
  printAllUsageQrLoading: string;
  printAllUsageQrHint: string;
  festivalGiftsNav: string;
  festivalGiftsTitle: string;
  festivalGiftsDesc: string;
  festivalGiftsLoading: string;
  festivalNoGifts: string;
  festivalStatUnused: string;
  festivalStatUsed: string;
  festivalStatTotal: string;
  festivalStatStores: string;
  festivalParticipatingStores: string;
  festivalStoreCount: string;
  festivalAllStores: string;
  festivalCouponsCount: string;
  festivalStoreUnusedShort: string;
  festivalSelectStoreHint: string;
  festivalNoGiftsInStore: string;
  printAllUsageQrHintStore: string;
  claimFreeCoupon: string;
  claimFreeCouponLoading: string;
  festivalClaimSuccess: string;
  festivalClaimFailed: string;
  freeCouponPrice: string;
  festivalGiftPageHint: string;
  loginRequiredForCoupon: string;
  money: string;
  orderForm: string;
  orderProductInfo: string;
  orderBuyerInfo: string;
  orderGiftMethod: string;
  orderPaymentSummary: string;
  orderProductAmount: string;
  orderTotalAmount: string;
  orderPayLoading: string;
  couponSelectTitle: string;
  couponSelectHint: string;
  couponDiscountLabel: string;
  couponMaxReached: string;
  couponSelectedSummary: (count: number, amount: string) => string;
  couponOverLimit: string;
  couponUnusable: string;
  couponNotUsableAtConfirm: string;
  buyerEmail: string;
  afterReceivingGift: string;
  month: string;
  day: string;
  noValidityInfo: string;
  giftDetails: string;
  giftState: string;
  receiveGiftInstructions: string;
  clickLink: string;
  validity: string;
  giftCondition: string;
  giftSerialNumber: string;
  senderName: string;
  senderPhoneNumber: string;
  senderEmailAddress: string;
  giftMessageText: string;
  giftReceiveLinkText: string;
  giftReceiveSuccess: string;
  giftReceiveFailure: string;
  giftSendSuccess: string;
  giftSendFailure: string;
  giftVerificationSuccess: string;
  giftVerificationFailure: string;
  giftClaimSuccess: string;
  giftClaimFailure: string;
  giftRefunded: string;
  giftRefundedDescription: string;
  checkSentGiftMessage: string;
  checkReceivedGift: string;
  reason: string;
  paymentError: string;
  expiredValidity: string;
  verificationReason: string;
  claimReason: string;
  /** 선물받기 실패 — 잘못된·변조 URL 처리 (400 등) */
  claimFailureInvalidLink: string;
  /** 선물받기 실패 — 데이터 없음 (404) */
  claimFailureNotFound: string;
  /** 선물받기 실패 — 중복 요청·이미 수령 등 (409 중 일부) */
  claimFailureDuplicate: string;
  /** 선물받기 실패 — 기타 */
  claimFailureUnknown: string;
  totalIssued: string;
  totalSold: string;
  totalSalesAmount: string;
  registrationDate: string;
  giftId: string;
  verificationSuccess: string;
  verificationFailed: string;
  adminLogout: string;
  userLogin: string;
  userGuide: string;
  guideFlowLead: string;
  guideRoleFlow: string;
  guideSwipeHint: string;
  guidePagerIntro: string;
  guideClose: string;
  guideBackToShop: string;
  guideActorBuyer: string;
  guideActorFriend: string;
  guideActorStore: string;
  guideFlowStep1Title: string;
  guideFlowStep1Desc: string;
  guideFlowStep1Image: string;
  guideFlowStep2Title: string;
  guideFlowStep2Desc: string;
  guideFlowStep2Image: string;
  guideFlowStep3Title: string;
  guideFlowStep3Desc: string;
  guideFlowStep3Image: string;
  guideFlowStep4Title: string;
  guideFlowStep4Desc: string;
  guideFlowStep4Image: string;
  guideFlowStep5Title: string;
  guideFlowStep5Desc: string;
  guideFlowStep5Image: string;
  guideFlowStep6Title: string;
  guideFlowStep6Desc: string;
  guideFlowStep6Image: string;
  guideFlowStep7Title: string;
  guideFlowStep7Desc: string;
  guideFlowStep7Image: string;
  guideFlowStep8Title: string;
  guideFlowStep8Desc: string;
  guideFlowStep8Image: string;
  guideFlowStep9Title: string;
  guideFlowStep9Desc: string;
  guideFlowStep9Image: string;
  guideFlowStep10Title: string;
  guideFlowStep10Desc: string;
  guideFlowStep10Image: string;
  userLogout: string;
  footerAddress: string;
  phone: string;
  email: string;
  giftHome: string;
  poweredBy: string;
  stateDesc: StateDesc;
  refundStateDesc: RefundStateDesc;
  saleStartDate: string;
  saleEndDate: string;
  kakaoGiftLink: string;
  kakaoShare: string;
  copyPaymentHint: string;
  smsPaymentHint: string;
  kakaoPaymentHint: string;
  copyPaymentComplete: string;
  copyPaymentInstruction: string;
  smsPaymentComplete: string;
  smsPaymentInstruction: string;
  kakaoPaymentComplete: string;
  kakaoPaymentInstruction: string;
  giftIdLabel: string;
  kakaoLogin: string;
  naverLogin: string;
  googleLogin: string;
  appleLogin: string;
  male: string;
  female: string;
  toggleLanguageKo: string;
  toggleLanguageEn: string;
  verifyConfirmMessage: string;
  verifyCompletedMessage: string;
  verifyFailedMessage: string;
  verifyGuideMessage: string;
  verifyingInProgress: string;
  viewQr: string;
  qrModalTitle: string;
  qrModalClose: string;
  /** [APP-FORK] 상점 진입 QR 분기 화면(AppQrEntry.tsx) */
  qrEntryChoiceMessage: string;
  qrEntryGoStore: string;
  qrEntryVerify: string;
  qrEntryStoreInfo: string;
  qrEntryStoreTitleSuffix: string;
  /** [APP-FORK] 선물 검증하기 진입(/:storeNo/verify) 시 코치마크 안내 — ReceivedRoot.tsx */
  verifyGuideCoachText: string;
  verifyGuideCoachShowToOwner: string;
  verifyGuideCoachDismiss: string;
  [key: string]: any;
}

interface TranslationObject {
  ko: Translations;
  en: Translations;
}

const translations: TranslationObject = {
  ko: {
    home: '홈',
    receivedGifts: '받은 선물함',
    sentGifts: '구매내역',
    integratedGiftBox: '통합선물함',
    storeInfo: '상점정보',
    storeInfoBasicTitle: '기본정보',
    storeInfoContactTitle: '위치·연락처',
    storeInfoNaverMap: '네이버',
    storeInfoKakaoMap: '카카오',
    storeInfoInstagram: '인스타',
    storeInfoEmpty: '상점 정보를 불러오지 못했습니다.',
    orderDatePrefix: '결제',
    orderDetailLink: '상세보기',
    orderStoreNameLabel: '상점명',
    orderRecipientLabel: '받는 분',
    orderRecipientSelf: '나에게',
    orderRecipientPending: '선물 미수신',
    orderRecipientReceived: '수신 완료',
    orderStatusComplete: '주문 완료',
    orderStatusPurchaseFail: '구매 실패',
    orderStatusPurchasePending: '구매 요청',
    orderStatusReprocess: '재처리 요청',
    orderRecvUnreceived: '미수신',
    orderRecvReceived: '수신',
    giftVersionLabel: '버전',
    giftSerialNoLabel: '시리얼',
    giftStatus: '기프트 현황',
    giftVerification: '기프트 셀프검증하기',
    verifyConfirmMessage: '선택한 기프트를 검증 처리하시겠습니까?',
    verifyCompletedMessage: '기프트 검증이 완료되었습니다.',
    verifyFailedMessage: '기프트 검증에 실패했습니다.',
    verifyGuideMessage:
      '상점에 방문해서 선물하기 QR 스캔 후 기프트를 셀프검증하고, 검증성공 화면을 상점주에게 보여주세요.',
    verifyingInProgress: '검증 중...',
    couponBoxTitle: '쿠폰함',
    couponBoxDesc: '받은 쿠폰을 매장에서 직접 사용하거나, 기프트 구매 시 결제 화면에서 선택해 쓸 수 있어요.',
    couponBoxLoading: '쿠폰함을 불러오는 중...',
    emptyCoupons: '보유한 쿠폰이 없습니다',
    couponAtThisStoreBanner: '지금 이 매장에서 쿠폰을 바로 사용할 수 있어요',
    couponUseHere: '이 매장에서 사용',
    couponUsingInProgress: '사용 처리 중...',
    couponVerifyConfirmMessage: '선택한 쿠폰을 이 매장에서 사용 처리하시겠습니까?',
    couponVerifySuccessMessage: '쿠폰이 사용 처리됐습니다. 상점 직원에게 확인해주세요.',
    couponVerifyFailedMessage: '쿠폰 사용 처리에 실패했습니다.',
    couponShowQrGuide: '이 QR을 상점 직원에게 보여주시면 검증해드립니다.',
    couponDiscountAmountLabel: '할인 금액',
    couponExpiryLabel: '사용기한',
    couponNoExpiry: '기한 없음',
    couponTabPending: '보유중',
    couponTabUsed: '사용완료',
    // [2026-10-22 A-F1] 쿠폰받기 · 상점 쿠폰함
    couponMyTab: '내 쿠폰함',
    couponClaimTab: '쿠폰받기',
    couponClaimTitle: '쿠폰받기',
    couponClaimDesc: '받기를 누르면 쿠폰함에 담겨요. 결제할 때나 매장에서 바로 쓸 수 있어요.',
    couponClaimLoading: '쿠폰을 불러오는 중...',
    couponClaimEmpty: '지금 받을 수 있는 쿠폰이 없어요',
    couponClaimButton: '받기',
    couponClaimDone: '받기 완료',
    couponClaimSoldOut: '마감',
    couponClaimSuccess: '쿠폰함에 담았어요',
    couponClaimFailed: '쿠폰을 받지 못했어요. 잠시 후 다시 시도해 주세요.',
    couponDiscountSuffix: '할인',
    couponPerUser: '1인 {n}장',
    couponRemain: '남은 수량 {n}장',
    couponUntil: '{date}까지',
    couponScopePlatform: '전체 상점에서 사용',
    couponScopeChannel: '{name} 참여 상점에서 사용',
    couponScopeStore: '{name}에서 사용',
    couponIssuerPlatform: '내기프트',
    storeCouponBoxTitle: '이 상점 쿠폰함',
    storeCouponBoxDesc: '이 상점에서 쓸 수 있는 내 쿠폰이에요.',
    couponShowQrButton: '매장에서 사용하기 (QR 보기)',
    couponQrShort: 'QR 사용',
    couponAmountUnit: '원 할인',
    couponFlipBack: '쿠폰 정보로 돌아가기',
    sendGift: '지인에게 선물하기',
    selfGift: '나에게 선물하기',
    inStock: '재고 있음',
    remainingStock: '남은 수량',
    giftTargetSelf: '나에게',
    giftTargetFriend: '지인에게',
    giftTargetReceived: '선물 받음',
    // [2026-10-28] 룰렛 경품으로 연결된 기프트 표시(구매 계정 · 당첨자)
    roulettePrizeBadge: '룰렛 경품',
    roulettePrizeSentTitle: '룰렛 경품으로 등록된 기프트예요',
    roulettePrizeSentGuide: '받기 링크는 보내지 마세요. 당첨자에게 자동으로 전달됩니다.',
    roulettePrizeSentDelivered: '룰렛 당첨자에게 전달된 경품이에요',
    roulettePrizeRefundGuide:
      '경품으로 연결된 동안은 환불할 수 없어요. 환불하려면 관리 화면 회차관리에서 경품 연결을 먼저 해제해 주세요.',
    roulettePrizeReceivedTitle: '축하해요! 룰렛 이벤트 당첨 경품이에요',
    roulettePrizeReceivedGuide: '매장에서 QR을 보여주고 사용하세요. 환불과 유효기간 연장은 안 되니 기간 안에 사용해 주세요.',
    validityPeriodDate: '유효기간 : ',
    validityPeriod: (months: number) => `유효기간 : 구매일로부터 ${months}개월`,
    paymentCondition: (hours: number) =>
      `지급조건 : 기프트 QR 코드 스캔 후 ${hours}시간 후 구매대금 상점으로 자동송금(환불불가)`,
    refundCondition:
      '환불조건 : 기프트 셀프검증 또는 기프트 QR 스캔 후 환불 불가',
    refundNoticeTab: '환불 및 연장 안내',
    refundLabel: '환불',
    refundNoticeBuyerRefund: '구매자 환불 (상대방 수락 전)',
    refundNoticeBuyerDesc1: '유효기간 내에만 신청 가능',
    refundNoticeBuyerDesc2:
      '환불 신청없이 유효기간이 경과한 경우 결제 취소 가능시 결제 취소되며, 결제 취소 불가시 입력한 계좌로 실제 결제액의 90% 환불',
    refundNoticeReceiverRefund: '수신자 환불',
    refundNoticeReceiverDesc1: '실결제가의 90% 환불',
    refundNoticeReceiverDesc2: '유효기간 내 요청 필수 (만료 시 환불 불가)',
    refundNoticeExtension: '기간 연장',
    refundNoticeExtensionDesc:
      '수신자가 직접 연장을 신청할 수 있으며, 최초 발행일로부터 최대 1년까지 가능해요.',
    refundNoticeDetail: '자세한 안내',
    refundNoticePolicyTitle: '1. 정책',
    refundNoticePolicy1Title: '1) 구매자 환불',
    refundNoticePolicy1Intro:
      '상대방이 아직 선물을 받지 않은 상태에서 구매자가 요청할 수 있습니다.',
    refundNoticePolicy1Item1:
      '조건: 상대방 수락 전 + 유효기간 내에만 신청 가능합니다.',
    refundNoticePolicy1Item2:
      '환불 신청없이 유효기간이 경과한 경우 결제 취소 가능시 결제 취소되며, 결제 취소 불가시 입력한 계좌로 실제 결제액의 90%가 환불됩니다.',
    // refundNoticePolicy1Item3:
    //   '방법: 보낸 선물함에서 환불 요청을 진행해 주세요.',
    refundNoticePolicy2Title: '2) 수신자 환불',
    refundNoticePolicy2Item1:
      '금액: 실결제가의 90%에 대해 환불 요청이 가능합니다.',
    refundNoticePolicy2Item2:
      '조건: 유효기간 이내에 사용하지 않은 기프트에 한해 신청하실 수 있습니다.',
    refundNoticePolicy2Item3:
      '방법: 받은 선물함에서 환불 요청을 진행해 주세요.',
    refundNoticePolicy3Title: '3) 유효기간 및 만료 정책',
    refundNoticePolicy3Item1: '기본 유효기간: 발행일 포함 3개월입니다.',
    refundNoticePolicy3Item2:
      '기간 연장: 유효기간 경과 전 수신자의 요청에 따라 3개월 단위로 연장 가능하며, 최초 발행일로부터 최대 1년까지 가능합니다.',
    refundNoticePolicy3Item3:
      '유효기간 만료: 유효기간이 만료된 기프트는 환불이 불가하며 소멸됩니다. 반드시 기간 내에 사용하시거나 환불을 요청해 주시기 바랍니다.',
    refundNoticePaymentTitle: '2. 환불금 지급 안내',
    refundNoticePaymentItem1:
      '신청하신 환불 건은 영업일 기준 최대 30일(한 달) 이내에 입력하신 계좌로 입금됩니다.',
    refundNoticePaymentItem2:
      '환불 신청 완료 후에는 취소 및 원상복구가 불가능하므로 신중하게 결정해 주시기 바랍니다.',
    refundNoticePaymentItem3:
      '반드시 본인 명의의 계좌 정보를 입력해 주세요. 성함과 계좌번호가 일치하지 않을 경우 입금이 지연될 수 있습니다.',
    refundNoticeNoteTitle: '3. 유의사항',
    refundNoticeNoteItem1:
      '환불은 신청 시 기입한 본인 명의의 계좌로 현금 입금됩니다.',
    refundNoticeNoteItem2:
      '매장에서 셀프검증을 하거나 기프트 QR 코드를 스캔하여 사용 처리가 완료된 기프트는 환불이 불가합니다.',
    refundNoticeNoteItem3:
      '수신자 연락처 오기입으로 이미 사용되었거나, 환불 계좌를 잘못 입력하여 발생한 오환불은 판매자가 책임지지 않습니다.',
    refundNoticeNoteItem4:
      '프로모션 또는 제휴사 계약에 따라 별도 조건이 적용된 경우나 할인쿠폰, 증정 등 현금 결제가 수반되지 않은 상품은 환불이 제한될 수 있습니다.',
    giftSerial: '기프트 시리얼 : ',
    paymentDate: '결제 일자 :',
    state: '상태 :',
    usageState: '사용 상태 :',
    refundState: '환불상태 :',
    giftStateLabel: '기프트 상태 :',
    sender: '보낸 사람 :',
    senderPhone: '보낸 사람 전화번호 :',
    senderEmail: '보낸 사람 이메일 :',
    giftMessage: '선물문구 :',
    unused: '사용전',
    unavailable: '사용불가',
    all: '전체',
    sendGiftAction: '선물 전달 방법',
    copyGiftLink: '링크 복사하여 직접 전달',
    sendGiftLinkInstruction: '문자(SMS) 또는 이메일로 전송',
    makePayment: '결제하기',
    giftSuccess: '기프트 선물하기 성공!',
    checkSentGift: '구매내역에서 확인하실 수 있습니다.',
    recipientPhone: '받는 분 전화번호',
    recipientEmail: '받는 분 이메일',
    giftNote: '선물문구 :',
    within50Chars: '',
    giftReceiveLink: '선물받기 링크',
    copyLink: '링크 복사하기',
    giftQr: '기프트 QR 코드',
    printAllUsageQr: '미사용 쿠폰 전체 인쇄 (앞·뒤)',
    printAllUsageQrLoading: '인쇄 준비 중…',
    printAllUsageQrHint: '앞면=상점 사용 QR · 뒷면=상점 진입 QR',
    festivalGiftsNav: '축제 쿠폰함',
    festivalGiftsTitle: '축제 쿠폰 관리',
    festivalGiftsDesc:
      '0원 축제·이벤트 쿠폰만 모아 관리합니다. 상점을 선택해 쿠폰 목록·인쇄를 진행하세요.',
    festivalGiftsLoading: '축제 쿠폰을 불러오는 중입니다...',
    festivalNoGifts: '표시할 축제 쿠폰이 없습니다.',
    festivalStatUnused: '미사용',
    festivalStatUsed: '사용완료·만료',
    festivalStatTotal: '전체',
    festivalStatStores: '보유 상점',
    festivalParticipatingStores: '상점별 보유 쿠폰',
    festivalStoreCount: '총 {n}곳',
    festivalAllStores: '전체 상점',
    festivalCouponsCount: '{n}장',
    festivalStoreUnusedShort: '미사용 {n}',
    festivalSelectStoreHint:
      '상점 칩 또는 카드를 누르면 해당 상점 쿠폰만 아래에 표시됩니다. 괄호 안 숫자는 미사용 수입니다.',
    festivalNoGiftsInStore: '{store} 상점에 표시할 쿠폰이 없습니다.',
    printAllUsageQrHintStore: '{store} 미사용 쿠폰만 인쇄합니다 (앞·뒤)',
    claimFreeCoupon: '이벤트 쿠폰 받기',
    claimFreeCouponLoading: '쿠폰 받는 중…',
    festivalClaimSuccess: '축제 쿠폰이 축제 쿠폰함에 담겼습니다.',
    festivalClaimFailed: '쿠폰 받기에 실패했습니다.',
    freeCouponPrice: '무료',
    festivalGiftPageHint:
      '결제 없이 쿠폰을 받습니다. 받은 뒤 축제 쿠폰함에서 사용 QR을 확인·인쇄할 수 있습니다.',
    loginRequiredForCoupon: '쿠폰을 받으려면 로그인해 주세요.',
    money: '원',
    orderForm: '주문서',
    orderProductInfo: '상품 정보',
    orderBuyerInfo: '구매자 정보',
    orderGiftMethod: '선물 방법',
    orderPaymentSummary: '결제 금액',
    orderProductAmount: '상품금액',
    orderTotalAmount: '총 결제금액',
    orderPayLoading: '결제 준비 중...',
    couponSelectTitle: '쿠폰 적용',
    couponSelectHint: '적용할 쿠폰을 선택하세요 (여러 장 가능)',
    couponDiscountLabel: '쿠폰 할인',
    couponMaxReached: '결제 금액이 0원이 되는 쿠폰은 선택할 수 없습니다',
    couponSelectedSummary: (count: number, amount: string) => `${count}장 · -${amount}원`,
    couponOverLimit: '선택 불가',
    couponUnusable: '사용 불가',
    couponNotUsableAtConfirm: '선택한 쿠폰을 더 이상 사용할 수 없어 결제가 진행되지 않았습니다. 쿠폰을 다시 선택해 결제해 주세요.',
    buyerEmail: '이메일',
    afterReceivingGift: '선물 받은 후',
    month: '달',
    day: '일',
    noValidityInfo: '유효기간 정보 없음',
    giftDetails: '선물내역',
    giftState: '미사용',
    receiveGiftInstructions: '기프트 선물을 받으시려면',
    clickLink: '아래 링크를 클릭',
    validity: '유효기간 :',
    giftCondition:
      '지급조건 : 기프트 QR 코드 스캔 후 1시간 후 구매대금 상점으로 자동송금(환불불가)',
    giftSerialNumber: '기프트 시리얼 : ',
    senderName: '보낸 사람 :',
    senderPhoneNumber: '보낸 사람 전화번호 :',
    senderEmailAddress: '보낸 사람 이메일 :',
    giftMessageText: '선물 문구',
    giftReceiveLinkText: '선물받기 링크',
    giftReceiveSuccess: '선물받기 성공',
    giftReceiveFailure: '선물받기 실패',
    giftSendSuccess: '기프트 선물하기 성공!',
    giftSendFailure: '기프트 선물하기 실패!',
    giftVerificationSuccess: '기프트 검증 성공!',
    giftVerificationFailure: '기프트 검증 실패!',
    giftClaimSuccess: '기프트 선물받기 성공!',
    giftClaimFailure: '기프트 선물받기 실패!',
    giftRefunded: '이 선물은 환불 처리되었습니다.',
    giftRefundedDescription:
      '구매자가 환불을 요청하여 이 선물은 받을 수 없습니다.',
    checkSentGiftMessage: '구매내역에서 확인하실 수 있습니다.',
    checkReceivedGift: '받은 기프트는 받은 선물함에서 확인하실 수 있습니다.',
    reason: '사유 :',
    paymentError: '결제 오류',
    expiredValidity: '유효기간 경과',
    verificationReason: '검증 실패 사유 :',
    claimReason: '받기 사유 :',
    claimFailureInvalidLink: '잘못된 선물받기 주소이거나 변경된 링크입니다',
    claimFailureNotFound: '선물 정보를 찾을 수 없습니다',
    claimFailureDuplicate: '이미 처리된 선물받기입니다',
    claimFailureUnknown:
      '선물받기를 완료할 수 없습니다. 잠시 후 다시 시도하거나 공유받은 원본 링크를 확인해 주세요',
    totalIssued: '총발행수량',
    totalSold: '누적판매수량',
    totalSalesAmount: '누적판매금액',
    registrationDate: '등록일',
    giftId: '기프트 아이디',
    verificationSuccess: '검증 성공',
    verificationFailed: '검증 실패',
    adminLogout: '관리자 로그아웃',
    userLogin: '로그인',
    userGuide: '이용 안내',
    guideFlowLead: '내기프트 이용 안내입니다. 각 단계별로 확인해주세요.',
    guideRoleFlow: '흐름 요약',
    guideSwipeHint: '아래로 넘기면 단계별 화면을 볼 수 있어요 ↓',
    guidePagerIntro: '소개',
    guideClose: '닫기',
    guideBackToShop: '기프트샵으로 돌아가기',
    guideActorBuyer: '구매자',
    guideActorFriend: '받는 분',
    guideActorStore: '가게',
    guideFlowStep1Title: '홈 화면',
    guideFlowStep1Desc:
      '가게 기프트샵 홈 화면에서 판매 중인 기프트 목록을 확인합니다.',
    guideFlowStep1Image: '홈 화면',
    guideFlowStep2Title: '원하는 기프트 선택',
    guideFlowStep2Desc:
      '기프트를 고르고 선물 방식(링크 복사 · SMS/이메일 · 카카오 등)을 선택합니다.',
    guideFlowStep2Image: '기프트 선택',
    guideFlowStep3Title: '결제하기 · 결제완료',
    guideFlowStep3Desc:
      '로그인·약관 동의 후 토스 등으로 결제를 진행하고, 결제완료 페이지까지 확인합니다.',
    guideFlowStep3Image: '결제완료 페이지',
    guideFlowStep4Title: '선물받기 링크 전달 · 카카오톡 공유',
    guideFlowStep4Desc:
      '결제가 끝나면 선물받기 링크가 만들어집니다. 카카오톡 등으로 공유하고, 받는 분이 공유받는 것까지 진행합니다.',
    guideFlowStep4Image: '카카오톡 공유',
    guideFlowStep5Title: '선물받기 페이지',
    guideFlowStep5Desc:
      '받는 분이 공유받은 선물받기 링크를 열어 선물받기 페이지로 이동합니다.',
    guideFlowStep5Image: '선물받기 페이지',
    guideFlowStep6Title: '받은 선물함 확인',
    guideFlowStep6Desc:
      '선물 받기를 완료하면 받은 선물함에서 기프트를 확인합니다.',
    guideFlowStep6Image: '선물 받기 · 받은 선물함',
    guideFlowStep7Title: '상점 QR 스캔',
    guideFlowStep7Desc:
      '내기프트 앱에서 하단 QR스캔 선택 후 매장 프론트에 있는 내기프트 QR코드를 스캔하세요. 꼭 스캔하셔야 셀프검증이 가능해요',
    guideFlowStep7Image: '상점 QR 스캔',
    guideFlowStep8Title: '앱 분기 화면',
    guideFlowStep8Desc:
      '가이드메뉴에서 “사용할래요”를 선택하면 받은 선물함으로 이동해요.',
    guideFlowStep8Image: '앱 분기 화면',
    guideFlowStep9Title: '사용할래요 · 셀프검증',
    guideFlowStep9Desc:
      "'사용할래요'를 선택한 뒤, 받은 선물함에서 원하는 기프트를 확인후 셀프 검증 버튼을 누릅니다.",
    guideFlowStep9Image: '기프트 셀프검증 버튼',
    guideFlowStep10Title: '검증 성공 · 상품 수령',
    guideFlowStep10Desc:
      '검증이 성공하면 성공 화면을 상점주에게 보여주세요. 상점주가 확인 후 계산을 진행합니다.',
    guideFlowStep10Image: '검증 성공',
    userLogout: '사용자 로그아웃',
    footerAddress:
      '인천 미추홀구 석정로 229, 811호 (도화동,인천블록체인허브센터)',
    phone: '010-1111-2222',
    email: 'bombom@gmail.com',
    giftHome: '기프트홈',
    giftLabel: '기프트',
    navAllGifts: '전체 기프트',
    navReceivedGifts: '받은 기프트',
    navSentGifts: '구매내역',
    navAllStoresReceived: '전체 상점 받은 기프트',
    navAllStoresSent: '전체 상점 구매 내역',
    navCoupons: '쿠폰함',
    poweredBy: 'Copyright by (주)오스리움. All Rights Reserved',
    stateDesc: {
      미사용: '미사용',
      사용완료: '사용완료',
      기사용오류: '기사용오류',
      유효기간오류: '유효기간오류',
      판매등록: '판매예정',
      판매예정: '판매예정',
      판매중지: '판매중지',
      판매시작: '판매시작',
      판매종료: '판매종료',
    },
    refundStateDesc: {
      환불요청: '환불요청',
      환불완료: '환불완료',
      '환불 완료': '환불완료',
      환불실패: '환불실패',
    },
    allStoresSentTitle: '구매내역',
    allStoresSentDesc:
      '결제한 기프트 주문을 확인하고 링크 공유·환불·재처리를 할 수 있어요.',
    sentGiftsLoading: '구매내역을 불러오는 중입니다...',
    allStoresReceivedTitle: '전체 상점 받은 기프트',
    allStoresReceivedDesc: '지금까지 받은 모든 기프트를 한 곳에서 확인하세요.',
    receivedGiftsLoading: '받은 기프트를 불러오는 중입니다...',
    giftShop: '기프트샵',
    claimHeaderDefault: '카페봄봄 기프트샵',
    saleStartDate: '판매시작일',
    saleEndDate: '판매종료일',
    kakaoGiftLink: '카카오톡으로 선물 보내기',
    kakaoShare: '카카오톡으로 선물',
    copyPaymentHint:
      '결제 완료 후 선물받기 링크가 생성됩니다. 링크를 복사하여 선물받을 분에게 직접 전달해주세요.',
    smsPaymentHint:
      '결제 완료 후 입력하신 전화번호 또는 이메일로 선물받기 링크가 자동 전송됩니다.',
    kakaoPaymentHint:
      '결제가 완료되면 카카오톡 버튼을 눌러 친구를 선택하여 선물을 보낼 수 있습니다.',
    copyPaymentComplete: '결제가 완료되었습니다!',
    copyPaymentInstruction:
      '아래 링크를 복사하여 선물받을 분에게 전달해주세요.',
    smsPaymentComplete: '결제가 완료되었습니다!',
    smsPaymentInstruction: '입력하신 연락처로 선물받기 링크가 전송되었습니다.',
    kakaoPaymentComplete: '결제가 완료되었습니다!',
    kakaoPaymentInstruction: '아래 버튼을 눌러 친구에게 선물을 전달해주세요.',
    giftIdLabel: '기프트 ID : ',
    logoAlt: 'Naegift',
    serviceIntro: '서비스 소개',
    storeSupport: '상점 지원',
    logout: '로그아웃',
    myPage: '마이페이지',
    login: '로그인',
    signup: '회원가입',
    defaultNickname: '고객',
    numbersOnly: '숫자만 입력해주세요.',
    validEmailRequired: '올바른 이메일 형식을 입력해주세요.',
    phoneRequired: '전화번호를 입력해주세요.',
    emailRequired: '이메일을 입력해주세요.',
    selectRequired: '선택 필요',
    selectReceiveMethod: '선물받기 방법을 선택해주세요.',
    inputRequired: '입력 필요',
    giftNoteRequired: '선물 문구를 입력해주세요.',
    purchaseUnavailable: '해당 기프트는 현재 구매할 수 없습니다.',
    purchaseBlocked: '구매 불가',
    testGift: '테스트 기프트',
    giftDisabled: '이미 중지된 기프트 입니다',
    paymentLoadFailed: '결제 정보를 불러오지 못했습니다.',
    amountMismatch: '결제 금액이 일치하지 않습니다.',
    paymentCheckError: '결제 정보 확인 중 오류가 발생했습니다.',
    paymentApprovalError: '결제 승인 중 오류가 발생했습니다.',
    copyToClipboard: '클립보드에 복사 되었습니다',
    allStoreGifts: '전체 상점 기프트',
    allStoreGiftsDesc: '모든 상점에서 판매 중인 기프트를 한 곳에서 확인하세요.',
    searchHint:
      '문장으로 물어보면 AI가 찾아줘요. (예: 인천에 있는 음식점, 서울 동작구에 위치한 카페 찾아줘)',
    searchHintKeyword:
      '상점명, 기프트명, 지역·주소 키워드로 빠르게 찾을 수 있어요.',
    searchPlaceholder: '인천에 위치한 카페, 서울 동작구에 위치한 카페 찾아줘',
    searchPlaceholderKeyword:
      '예: 내카페, 아메리카노, 스테이크, 인천 연수구, 중구',
    marketSearchModeAi: 'AI 검색',
    marketSearchModeKeyword: '키워드',
    marketChannelAll: '전체',
    marketChannelFilter: '채널',
    marketChannelMore: '더보기',
    marketChannelFold: '접기',
    searchLabel: '검색',
    searching: '검색중...',
    noSearchResult: '검색 결과가 없습니다.',
    noGiftsToShow: '표시할 기프트가 없습니다.',
    emptyUnusedGifts: '사용 전 기프트가 없습니다',
    emptyUnavailableGifts: '사용 불가 기프트가 없습니다',
    emptyReceivedGifts: '받은 기프트가 없습니다',
    emptyPurchaseHistory: '구매내역이 없습니다',
    // 구매내역(Sent) 전용 빈 상태. 받은(Received)과 문구가 달라야 해 emptyUnused/UnavailableGifts 와 분리.
    emptyUnusedPurchaseHistory: '사용 전 구매내역이 없습니다',
    emptyUnavailablePurchaseHistory: '사용 불가 구매내역이 없습니다',
    noProductsYet: '기프트 준비중입니다',
    productsComingSoon: '곧 만나보실 수 있어요',
    noStoreInfo: '상점 정보 없음',
    marketStoreLocation: '위치',
    marketStoreLocationMissing:
      '등록된 위치 정보가 없어요. 상점 페이지에서 자세한 안내를 확인할 수 있어요.',
    marketViewStore: '상점 홈',
    marketStoreAddress: '주소 : ',
    marketOpenMap: '지도',
    giftImageAlt: '기프트 이미지',
    noDescription: '설명 없음',
    loadMore: '더 불러오는 중...',
    maxBenefitPrice: '최대혜택가',
    allGiftsLoaded: '모든 기프트를 불러왔습니다.',
    bank: '은행',
    accountNo: '계좌번호',
    accountHolder: '예금주',
    applicantName: '이름',
    applicantPhone: '휴대폰번호',
    refundReason: '환불 사유',
    cancel: '취소',
    refundSubmit: '환불 접수',
    refundCancelNotice: '환불 요청 시 선물하기가 취소됩니다.',
    giftDetailsTitle: '선물 상세정보',
    giftReceiveGo: '선물 받으러 가기',
    giftMemoDefault: '선물 설명입니다.',
    refundFeeNotice: '결제 금액에서 환불 수수료(10%)를 제외하고 환불됩니다.',
    selectBank: '은행을 선택해 주세요.',
    bankSelectOption: '은행 선택',
    accountNoRequired: '계좌번호를 입력해 주세요.',
    accountHolderRequired: '예금주를 입력해 주세요.',
    accountNoPlaceholder: '계좌번호 입력',
    accountHolderPlaceholder: '예금주 입력',
    accountHolderAutoPlaceholder: '이름을 입력하면 자동으로 입력됩니다',
    applicantNameRequired: '이름을 입력해 주세요.',
    applicantPhoneRequired: '휴대폰번호를 입력해 주세요.',
    applicantNamePlaceholder: '이름 입력',
    applicantPhonePlaceholder: '휴대폰번호 입력',
    refundReasonPlaceholder: '환불 사유 입력',
    refundSubmitted: '환불 요청이 접수되었습니다.',
    refundFailed: '환불 요청이 실패했습니다.',
    refundCannotReceive:
      '수신자가 이미 선물을 받았기 때문에 환불할 수 없습니다.',
    scanUnavailable: '스캔 불가',
    viewQr: 'QR 확인',
    qrModalTitle: 'QR 코드',
    qrModalClose: '닫기',
    qrEntryChoiceMessage: '무엇을 하시겠어요?',
    qrEntryGoStore: '선물할래요',
    qrEntryVerify: '사용할래요',
    qrEntryStoreInfo: '상점이 궁금해요',
    qrEntryStoreTitleSuffix: '기프트',
    verifyGuideCoachText:
      '사용하실 기프트에서 이 버튼을 누르면 기프트가 검증돼요',
    verifyGuideCoachShowToOwner: '검증성공화면을 가게 사장님에게 보여주세요',
    verifyGuideCoachDismiss: '화면을 터치하면 닫혀요',
    validityExpired: '유효기간 만료',
    usedOrRefunded: '사용 완료 또는 환불 처리됨',
    used: '사용완료',
    confirmRefundMessage:
      '환불요청 시 취소할 수 없습니다.\n환불요청을 진행하시겠습니까?',
    refundRequest: '환불요청',
    refundRequested: '환불요청',
    refundComplete: '환불 완료',
    refundFailedStamp: '환불실패',
    storeClosedRefundNotice: '상점이 영업을 종료하여 더 이상 이용할 수 없습니다. 환불을 신청해주세요.',
    requestReprocess: '구매 재처리 요청',
    requestReprocessLoading: '요청 중...',
    requestReprocessConfirm:
      '결제는 완료됐으나 구매 등록이 실패한 건입니다.\n재처리를 요청하시겠습니까?',
    requestReprocessSuccess:
      '재처리 요청이 완료되었습니다. 담당자가 확인 후 처리합니다.',
    requestReprocessFailed:
      '재처리 요청에 실패했습니다. 이미 요청된 건이거나 결제 상태를 확인해 주세요.',
    requestReprocessAlready: '이미 재처리 요청된 건입니다.',
    extendValidityAction: '유효기간 3개월 연장',
    extendValidityLoading: '연장 처리 중...',
    extendValidityConfirm:
      '유효기간을 3개월 연장하시겠습니까?\n(최초 결제일 포함 최대 1년까지만 가능합니다.)',
    extendValiditySuccess: '유효기간이 연장되었습니다.',
    extendValidityFailed:
      '유효기간 연장에 실패했습니다. 만료/환불 상태 또는 최대 연장(1년) 도달 여부를 확인해 주세요.',
    notReceived: '미수신',
    loading: '불러오는 중...',
    alreadyReceived: '이미 받은 선물입니다',
    checkReceivedGifts: '받은 선물함에서 선물을 확인하실 수 있습니다.',
    goToReceived: '받은 선물함으로 이동',
    selfGiftPurchaseComplete: '구매가 완료되었습니다.',
    claimGift: '선물받기',
    dataLoadError: '데이터를 불러오는 중 오류가 발생했습니다.',
    giftNotPurchasable: '지금은 구매할 수 없는 기프트입니다.',
    giftAmountLabel: '기프트 금액',
    paymentInfoTitle: '결제 정보',
    totalDiscountLabel: '총 할인받은 금액',
    paidAmountLabel: '결제금액',
    discountAppliedSuffix: '할인이 적용됐어요',
    paymentMethodTitle: '결제방법',
    paymentCanceled: '결제가 취소되었습니다. 다른 결제 수단을 선택해 주세요.',
    tryAgain: '잠시 후 다시 시도해 주세요.',
    paymentRequestFailed:
      '결제 요청에 실패했습니다. 새로고침 후 다시 시도해 주세요.',
    paymentParamMissing: '결제 확인 정보가 유실되었습니다. 다시 시도해 주세요.',
    loginRequired: '로그인 필요',
    loginRequiredText: '로그인이 필요합니다.',
    confirmButton: '확인',
    goToMarket: '마켓으로',
    storeLabel: '상점',
    toNameSuffix: '으로',
    toNamePrefix: '',
    bizNumLabel: '사업자등록번호',
    repLabel: '대표자',
    addressLabel: '주소',
    /** 푸터 상점 — 도로명(지번과 구분) */
    roadAddressLabel: '도로명 주소',
    jibunAddressLabel: '지번주소',
    storeNameLabel: '상호',
    operationHoursLabel: '고객센터 운영시간',
    phoneLabel: '전화번호',
    serviceTerms: '서비스이용약관',
    privacyPolicy: '개인정보처리방침',
    defaultRepresentative: '고승곤',
    defaultCompanyName: '(주)오스리움',
    defaultOperationHours: '평일 09:00 - 18:00',
    defaultOperationHoursNote:
      '(점심시간 12:00~13:00 미운영 / 주말 및 공휴일 휴무)',
    giftListLoadFailed: '기프트 목록을 불러오지 못했습니다.',
    searchError: '검색 중 오류가 발생했습니다.',
    withdrawError:
      '탈퇴 처리 중 오류가 발생했습니다. (API 준비 중일 수 있습니다)',
    withdrawCondition:
      '이 상점 기준: 보낸 선물은 상대가 아직 선물받기 하지 않은(미수신) 건만 탈퇴를 막습니다. 상대가 받은 뒤 미사용이어도 보낸 사람 입장에서는 탈퇴할 수 있습니다. 받은 선물(내 수신함)은 미사용이면 환불 완료 전까지 탈퇴할 수 없으며, 사용 완료·기사용 오류·환불 완료로 끝난 경우에만 탈퇴 가능합니다. 유효기간 오류 등도 정리 전까지는 탈퇴할 수 없습니다. 다른 상점 멤버십은 유지됩니다.',
    naverAuthFailed: '네이버 인증에 실패했습니다. 다시 시도해주세요.',
    consentSaveError: '동의 저장 중 오류가 발생했지만 계속 진행합니다.',
    myInfoTitle: '내 정보',
    naverAuthProcessing: '네이버 인증 처리 중입니다...',
    allAgree: '전체 동의하기',
    kakaoLogin: '카카오 로그인',
    naverLogin: '네이버 로그인',
    googleLogin: '구글 로그인',
    appleLogin: '애플 로그인',
    globalLoginTitle: '전체 상점 통합 로그인',
    globalLoginDesc:
      '한 번의 로그인으로 모든 상점 서비스를 이용할 수 있습니다.',
    backToAllStores: '전체 상점으로 돌아가기',
    male: '남성',
    female: '여성',
    withdrawButton: '탈퇴하기',
    withdrawFromStore: '이 상점 탈퇴',
    // [APP-FORK] 앱 탈퇴(soft delete) — store_user·선물 이력을 지우는 상점 탈퇴와 별개.
    withdrawApp: '앱 탈퇴',
    withdrawAppModal:
      '앱에서 탈퇴하면 로그아웃되며 약관 동의가 철회됩니다. 탈퇴하시겠습니까?',
    withdrawNeedStoreContext:
      '상점 정보를 확인할 수 없습니다. 상점 화면에서 내 정보로 진입한 뒤 다시 시도해 주세요.',
    withdrawModalStep1:
      '이 상점에서 탈퇴하면 미사용·미수신 기프트콘은 소멸되며 복구할 수 없습니다. 다른 상점 이용에는 영향이 없습니다. 계속하시겠습니까?',
    withdrawModalStep2:
      '탈퇴 후 이 상점에 다시 가입하면, 이전에 보낸·받은 선물 내역은 앱 목록에 표시되지 않습니다. 그래도 탈퇴하시겠습니까?',
    withdrawSuccessTitle: '탈퇴 완료',
    withdrawSuccessMessage: '이 상점에서 탈퇴되었으며 로그아웃되었습니다.',
    processing: '처리 중...',
    // 마켓홈 공지 팝업 (components/common/NoticePopup.tsx)
    noticeRequiredLabel: '필수 공지',
    noticeAgree: '동의',
    noticeDisagree: '동의하지 않음',
    noticeConfirm: '확인',
    noticeClose: '닫기',
    noticeConsentFailed:
      '동의 처리에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    noticeScrollToEnd: '내용을 끝까지 확인하셔야 동의할 수 있습니다.',
    noticeHideToday: '오늘 그만보기',
    // 약관 관문 팝업 (components/common/TermsPopup.tsx)
    termsPopupTitle: '내기프트 약관 동의',
    termsServiceLabel: '(필수) 이용약관 동의',
    termsPrivacyLabel: '(필수) 개인정보 수집 및 이용 동의',
    termsMarketingLabel: '(선택) 마케팅 정보 수신 동의',
    termsMarketingDesc:
      '이벤트, 할인 혜택, 신규 상품 안내 등 맞춤형 마케팅 정보를 수신합니다. 동의하지 않아도 서비스 이용에 제한이 없습니다.',
    termsView: '보기',
    termsSaveFailed: '동의 저장에 실패했습니다. 잠시 후 다시 시도해 주세요.',
    // 내 정보 알림 설정
    notificationSection: '알림 설정',
    marketingConsentLabel: '마케팅 정보 수신',
    // 상점홈 내정보는 store_user 의 상점별 동의라 대상 상점을 명시한다(캐시에 상점명이 없으면 폴백).
    marketingConsentStoreNameLabel: '{store} 마케팅 정보 수신',
    marketingConsentStoreLabel: '이 상점 마케팅 정보 수신',
    toggleLanguageKo: 'EN',
    toggleLanguageEn: '한글',
  },
  en: {
    home: 'Home',
    receivedGifts: 'Received gifts',
    sentGifts: 'Purchase history',
    integratedGiftBox: 'Gift box',
    storeInfo: 'Store info',
    storeInfoBasicTitle: 'Basic info',
    storeInfoContactTitle: 'Location & contact',
    storeInfoNaverMap: 'Naver',
    storeInfoKakaoMap: 'Kakao',
    storeInfoInstagram: 'Instagram',
    storeInfoEmpty: 'Failed to load store information.',
    orderDatePrefix: 'Paid',
    orderDetailLink: 'Details',
    orderStoreNameLabel: 'Store',
    orderRecipientLabel: 'To',
    orderRecipientSelf: 'Myself',
    orderRecipientPending: 'Not claimed yet',
    orderRecipientReceived: 'Claimed',
    orderStatusComplete: 'Order complete',
    orderStatusPurchaseFail: 'Purchase failed',
    orderStatusPurchasePending: 'Purchase Requested',
    orderStatusReprocess: 'Reprocess requested',
    orderRecvUnreceived: 'Unreceived',
    orderRecvReceived: 'Received',
    giftVersionLabel: 'Ver.',
    giftSerialNoLabel: 'Serial',
    validityPeriodDate: 'Validity period : ',
    giftStatus: 'Gift status',
    giftVerification: 'Gift verification',
    sendGift: 'Gift to friend',
    selfGift: 'Gift to myself',
    inStock: 'In stock',
    remainingStock: 'Remaining',
    giftTargetSelf: 'For me',
    giftTargetFriend: 'For a friend',
    giftTargetReceived: 'Received gift',
    roulettePrizeBadge: 'Roulette prize',
    roulettePrizeSentTitle: 'This gift is registered as a roulette prize',
    roulettePrizeSentGuide: 'Do not send the claim link — it will be delivered to the winner automatically.',
    roulettePrizeSentDelivered: 'This prize has been delivered to a roulette winner',
    roulettePrizeRefundGuide:
      'Refunds are not available while linked as a prize. Unlink it from the prize in the round management screen first.',
    roulettePrizeReceivedTitle: 'Congratulations! You won this in a roulette event',
    roulettePrizeReceivedGuide: 'Show the QR code at the store to use it. Prizes cannot be refunded or extended, so please use it before it expires.',
    verifyConfirmMessage: 'Do you want to verify this gift?',
    verifyCompletedMessage: 'Gift verification completed.',
    verifyFailedMessage: 'Gift verification failed.',
    verifyGuideMessage:
      'Please visit the store in person, verify the gift, and notify the store owner that verification is complete.',
    verifyingInProgress: 'Verifying...',
    couponBoxTitle: 'My Coupons',
    couponBoxDesc: 'Use your coupons in store, or select one at checkout when buying a gift.',
    couponBoxLoading: 'Loading your coupons...',
    emptyCoupons: 'No coupons yet',
    couponAtThisStoreBanner: 'You can use a coupon here right now',
    couponUseHere: 'Use at this store',
    couponUsingInProgress: 'Using coupon...',
    couponVerifyConfirmMessage: 'Use this coupon at this store?',
    couponVerifySuccessMessage: 'Coupon used. Please show this to store staff.',
    couponVerifyFailedMessage: 'Failed to use the coupon.',
    couponShowQrGuide: 'Show this QR to the store staff to verify.',
    couponDiscountAmountLabel: 'Discount',
    couponExpiryLabel: 'Expires',
    couponNoExpiry: 'No expiry',
    couponTabPending: 'Available',
    couponTabUsed: 'Used',
    // [2026-10-22 A-F1] Get coupons · store coupon box
    couponMyTab: 'My coupons',
    couponClaimTab: 'Get coupons',
    couponClaimTitle: 'Get coupons',
    couponClaimDesc: 'Tap Get to save a coupon. Use it at checkout or in store.',
    couponClaimLoading: 'Loading coupons...',
    couponClaimEmpty: 'No coupons available right now',
    couponClaimButton: 'Get',
    couponClaimDone: 'Saved',
    couponClaimSoldOut: 'Sold out',
    couponClaimSuccess: 'Saved to My coupons',
    couponClaimFailed: 'Could not get the coupon. Please try again later.',
    couponDiscountSuffix: 'off',
    couponPerUser: '{n} per person',
    couponRemain: '{n} left',
    couponUntil: 'Until {date}',
    couponScopePlatform: 'Usable at all stores',
    couponScopeChannel: 'Usable at {name} partner stores',
    couponScopeStore: 'Usable at {name}',
    couponIssuerPlatform: 'Naegift',
    storeCouponBoxTitle: 'Coupons for this store',
    storeCouponBoxDesc: 'Your coupons that can be used at this store.',
    couponShowQrButton: 'Use in store (show QR)',
    couponQrShort: 'Use QR',
    couponAmountUnit: 'KRW off',
    couponFlipBack: 'Back to coupon',
    validityPeriod: (months: number) =>
      `Validity period: ${months} months after purchase`,
    paymentCondition: (hours: number) =>
      `Payment condition: The purchase amount will be automatically remitted to the store ${hours} hours after the gift QR code is scanned (Non-refundable)`,
    refundCondition: 'Refund condition: Non-refundable after gift QR scan',
    refundNoticeTab: 'Refund & extension info',
    refundLabel: 'Refund',
    refundNoticeBuyerRefund: 'Buyer refund (before recipient acceptance)',
    refundNoticeBuyerDesc1: 'Request must be made within the validity period',
    refundNoticeBuyerDesc2:
      'Within 1 year: card payment cancellation (full) / After 1 year: 90% refund to the provided bank account',
    refundNoticeReceiverRefund: 'Recipient refund',
    refundNoticeReceiverDesc1: '90% of actual payment refund',
    refundNoticeReceiverDesc2:
      'Must request within validity period (No refund after expiry)',
    refundNoticeExtension: 'Period extension',
    refundNoticeExtensionDesc:
      'Recipients can request an extension directly, up to 1 year from the initial issue date.',
    refundNoticeDetail: 'View details',
    refundNoticePolicyTitle: '1. Policy',
    refundNoticePolicy1Title: '1) Buyer refund',
    refundNoticePolicy1Intro:
      'The buyer may request a refund when the recipient has not yet accepted the gift.',
    refundNoticePolicy1Item1:
      'Condition: Before acceptance and within the validity period.',
    refundNoticePolicy1Item2:
      'Within 1 year: payment cancellation (full). After 1 year: 90% refund to the provided bank account.',
    refundNoticePolicy2Title: '2) Recipient refund',
    refundNoticePolicy2Item1:
      'Amount: Refund of 90% of the actual payment is available.',
    refundNoticePolicy2Item2:
      'Condition: Only unused gifts within the validity period are eligible.',
    refundNoticePolicy2Item3: 'How: Request a refund from the received gifts.',
    refundNoticePolicy3Title: '3) Validity and expiry policy',
    refundNoticePolicy3Item1: 'Default validity: 3 months from the issue date.',
    refundNoticePolicy3Item2:
      'Extension: Recipients may request extensions in 3-month increments, up to 1 year from the initial issue date.',
    refundNoticePolicy3Item3:
      'Expiry: Expired gifts cannot be refunded and will be void. Please use or request a refund within the validity period.',
    refundNoticePaymentTitle: '2. Refund payment info',
    refundNoticePaymentItem1:
      'Refunds will be deposited to the provided account within 30 business days.',
    refundNoticePaymentItem2:
      'Refund requests cannot be cancelled or reversed once submitted. Please decide carefully.',
    refundNoticePaymentItem3:
      'Enter your own bank account details. Name and account number must match, or deposit may be delayed.',
    refundNoticeNoteTitle: '3. Important notes',
    refundNoticeNoteItem1:
      'Refunds are paid in cash to the account provided at the time of request.',
    refundNoticeNoteItem2:
      'Gifts used after QR code scan at the store cannot be refunded.',
    refundNoticeNoteItem3:
      'Sellers are not responsible for improper refunds due to incorrect recipient contact or account details.',
    refundNoticeNoteItem4:
      'Refunds may be restricted for products subject to promotions, partnership terms, or non-cash payments such as discount coupons or free gifts.',
    giftSerial: 'Gift serial : ',
    paymentDate: 'Payment date :',
    state: 'State :',
    usageState: 'Usage status :',
    refundState: 'Refund status :',
    giftStateLabel: 'Gift status :',
    sender: 'Sender :',
    senderPhone: 'Sender phone :',
    senderEmail: 'Sender email :',
    giftMessage: 'Gift message :',
    unused: 'Unused',
    unavailable: 'Unavailable',
    all: 'All',
    sendGiftAction: 'Gift delivery method',
    copyGiftLink: 'Copy link and send directly',
    sendGiftLinkInstruction: 'Send via SMS or email',
    makePayment: 'Make payment',
    giftSuccess: 'Gift sent successfully via Cafe Bombom!',
    checkSentGift: 'You can check it in Purchase history.',
    recipientPhone: 'Recipient phone',
    recipientEmail: 'Recipient email',
    giftNote: 'Gift message :',
    within50Chars: '',
    giftReceiveLink: 'Gift receive link',
    copyLink: 'Copy link',
    giftQr: 'Gift QR code',
    printAllUsageQr: 'Print all coupons (front & back)',
    printAllUsageQrLoading: 'Preparing print…',
    printAllUsageQrHint: 'Front = usage QR · Back = store entry QR',
    festivalGiftsNav: 'Festival coupons',
    festivalGiftsTitle: 'Festival coupon management',
    festivalGiftsDesc:
      'Manage 0-won festival and event coupons in one place. Select a store to view and print.',
    festivalGiftsLoading: 'Loading festival coupons...',
    festivalNoGifts: 'No festival coupons to show.',
    festivalStatUnused: 'Unused',
    festivalStatUsed: 'Used / expired',
    festivalStatTotal: 'Total',
    festivalStatStores: 'Stores',
    festivalParticipatingStores: 'Coupons by store',
    festivalStoreCount: '{n} stores',
    festivalAllStores: 'All stores',
    festivalCouponsCount: '{n} coupons',
    festivalStoreUnusedShort: '{n} unused',
    festivalSelectStoreHint:
      'Tap a store chip or card to filter the list below. Parentheses show unused count.',
    festivalNoGiftsInStore: 'No coupons to show for {store}.',
    printAllUsageQrHintStore: 'Print unused coupons for {store} (front & back)',
    claimFreeCoupon: 'Get event coupon',
    claimFreeCouponLoading: 'Claiming…',
    festivalClaimSuccess: 'Coupon added to your Festival coupon box.',
    festivalClaimFailed: 'Failed to claim coupon.',
    freeCouponPrice: 'Free',
    festivalGiftPageHint:
      'No payment required. View or print usage QR from the Festival coupon box.',
    loginRequiredForCoupon: 'Please log in to claim this coupon.',
    money: 'KRW',
    orderForm: 'Order form',
    orderProductInfo: 'Product info',
    orderBuyerInfo: 'Buyer info',
    orderGiftMethod: 'Gift method',
    orderPaymentSummary: 'Payment amount',
    orderProductAmount: 'Product amount',
    orderTotalAmount: 'Total',
    orderPayLoading: 'Loading payment...',
    couponSelectTitle: 'Apply coupons',
    couponSelectHint: 'Select coupons to apply (multiple allowed)',
    couponDiscountLabel: 'Coupon discount',
    couponMaxReached: 'Coupons that would make the payment 0 cannot be selected',
    couponSelectedSummary: (count: number, amount: string) => `${count} selected · -${amount} KRW`,
    couponOverLimit: 'Unavailable',
    couponUnusable: 'Unavailable',
    couponNotUsableAtConfirm: 'The selected coupon can no longer be used, so the payment was not made. Please choose coupons again.',
    buyerEmail: 'Email',
    afterReceivingGift: 'After receiving the gift',
    month: 'Months',
    day: 'Days',
    noValidityInfo: 'No validity information available',
    giftDetails: 'Gift details',
    giftDetailsTitle: 'Gift details',
    giftReceiveGo: 'Receive your gift',
    giftMemoDefault: 'Gift description.',
    giftState: 'Unused',
    receiveGiftInstructions: 'To receive the gift',
    clickLink: 'Please click the link below.',
    validity: 'Validity period:',
    giftCondition:
      'Payment condition: The purchase amount will be automatically remitted to the store 1 hour after scanning the gift QR code (Non-refundable)',
    giftSerialNumber: 'Gift serial : ',
    senderName: 'Sender :',
    senderPhoneNumber: 'Sender phone :',
    senderEmailAddress: 'Sender email :',
    giftMessageText: 'Gift message :',
    giftReceiveLinkText: 'Gift receive link',
    giftReceiveSuccess: 'Gift received successfully',
    giftReceiveFailure: 'Gift receiving failed',
    giftSendSuccess: 'Gift sent successfully!',
    giftSendFailure: 'Gift sending failed!',
    giftVerificationSuccess: 'Gift verification successful!',
    giftVerificationFailure: 'Gift verification failed!',
    giftClaimSuccess: 'Gift received successfully!',
    giftClaimFailure: 'Gift receiving failed!',
    giftRefunded: 'This gift has been refunded.',
    giftRefundedDescription:
      'The purchaser has requested a refund, so this gift cannot be received.',
    checkSentGiftMessage: 'You can check it in Purchase history.',
    checkReceivedGift: 'You can check the received gift in the received gifts.',
    reason: 'Reason:',
    paymentError: 'Payment error',
    expiredValidity: 'Expired validity',
    verificationReason: 'Verification failure reason :',
    claimReason: 'Claim reason :',
    claimFailureInvalidLink: 'Invalid gift link or the URL was changed',
    claimFailureNotFound: 'Gift information could not be found',
    claimFailureDuplicate: 'This gift has already been claimed',
    claimFailureUnknown:
      'Unable to receive the gift. Please try again or use the original shared link',
    totalIssued: 'Total issued',
    totalSold: 'Total sold',
    totalSalesAmount: 'Total sales amount',
    registrationDate: 'Registration date',
    giftId: 'Gift id',
    verificationSuccess: 'Verification success',
    verificationFailed: 'Verification failed',
    adminLogout: 'Admin logout',
    userLogin: 'Login',
    userGuide: 'User guide',
    guideFlowLead:
      'How NaeGift works. Screen images for each step can be replaced by your team.',
    guideRoleFlow: 'Flow summary',
    guideSwipeHint: 'Scroll down to see each step ↓',
    guidePagerIntro: 'Intro',
    guideClose: 'Close',
    guideBackToShop: 'Back to gift shop',
    guideActorBuyer: 'Buyer',
    guideActorFriend: 'Recipient',
    guideActorStore: 'Store',
    guideFlowStep1Title: 'Home screen',
    guideFlowStep1Desc:
      'Browse gifts for sale on the store gift shop home screen.',
    guideFlowStep1Image: 'Home screen',
    guideFlowStep2Title: 'Choose a gift',
    guideFlowStep2Desc:
      'Pick a gift and choose how to send it (link, SMS/email, Kakao, etc.).',
    guideFlowStep2Image: 'Choose a gift',
    guideFlowStep3Title: 'Pay · payment complete',
    guideFlowStep3Desc:
      'Log in, agree to terms, pay with Toss or similar, and confirm the payment-complete page.',
    guideFlowStep3Image: 'Payment complete page',
    guideFlowStep4Title: 'Share claim link · KakaoTalk',
    guideFlowStep4Desc:
      'After payment, a claim link is created. Share it via KakaoTalk and hand it off to the recipient.',
    guideFlowStep4Image: 'KakaoTalk share',
    guideFlowStep5Title: 'Claim page',
    guideFlowStep5Desc:
      'The recipient opens the shared claim link and goes to the claim page.',
    guideFlowStep5Image: 'Claim page',
    guideFlowStep6Title: 'Check received gifts',
    guideFlowStep6Desc:
      'After claiming, the gift is saved in the received box.',
    guideFlowStep6Image: 'Received gifts',
    guideFlowStep7Title: 'Scan store QR',
    guideFlowStep7Desc:
      'Visit the store and scan the store QR code displayed there.',
    guideFlowStep7Image: 'Store QR scan',
    guideFlowStep8Title: 'App branch screen',
    guideFlowStep8Desc:
      'After scanning the store QR, choose where to go from the screen shown.',
    guideFlowStep8Image: 'App branch screen',
    guideFlowStep9Title: 'Use a gift · self-verify',
    guideFlowStep9Desc:
      "Choose 'Use a gift', then tap the self-verify button in the received box.",
    guideFlowStep9Image: 'Self-verify button',
    guideFlowStep10Title: 'Verified · receive item',
    guideFlowStep10Desc:
      'After self-verification succeeds, the gift is marked used and the item is received.',
    guideFlowStep10Image: 'Verification success',
    userLogout: 'User logout',
    footerAddress:
      '229, Seokjeong-ro, Michuhol-gu, Incheon, 811 (Dohwa-dong, Incheon Blockchain Hub Center)',

    phone: '010-1111-2222',
    email: 'bombom@gmail.com',
    giftHome: 'Gift home',
    giftLabel: 'Gift',
    navAllGifts: 'All gifts',
    navReceivedGifts: 'Received gifts',
    navSentGifts: 'Purchase history',
    navAllStoresReceived: 'All stores received gifts',
    navAllStoresSent: 'All stores purchases',
    navCoupons: 'My Coupons',
    poweredBy: 'Copyright by Authrium Co., Ltd. All Rights Reserved.',
    stateDesc: {
      미사용: 'Unused',
      사용완료: 'Used',
      기사용오류: 'Use error',
      유효기간오류: 'Expired',
      판매등록: 'Planned sale',
      판매예정: 'Planned sale',
      판매중지: 'Sales discontinued',
      판매시작: 'Sale started',
      판매종료: 'Sale ended',
    },
    refundStateDesc: {
      환불요청: 'Refund Requested',
      환불완료: 'Refund Completed',
      '환불 완료': 'Refund Completed',
      환불실패: 'Refund Failed',
    },
    allStoresSentTitle: 'Purchase history',
    allStoresSentDesc:
      'View paid orders, share claim links, request refunds, or reprocess purchases.',
    sentGiftsLoading: 'Loading purchase history...',
    allStoresReceivedTitle: 'All stores received gifts',
    allStoresReceivedDesc: 'View all gifts you received in one place.',
    receivedGiftsLoading: 'Loading received gifts...',
    giftShop: 'Gift Shop',
    claimHeaderDefault: 'Cafe Bombom Gift Shop',
    saleStartDate: 'Sale start Date',
    saleEndDate: 'Sale end Date',
    kakaoGiftLink: 'Send gift via KakaoTalk',
    kakaoShare: 'Send via KakaoTalk',
    copyPaymentHint:
      'A gift link will be generated after payment. Copy the link and send it directly to the recipient.',
    smsPaymentHint:
      'After payment, the gift link will be automatically sent to the phone number or email you entered.',
    kakaoPaymentHint:
      'After payment, KakaoTalk will open and you can select a friend to send the gift.',
    copyPaymentComplete: 'Payment completed!',
    copyPaymentInstruction: 'Copy the link below and send it to the recipient.',
    smsPaymentComplete: 'Payment completed!',
    smsPaymentInstruction:
      'The gift link has been sent to the contact you entered.',
    kakaoPaymentComplete: 'Payment completed!',
    kakaoPaymentInstruction:
      'Press the button below to send the gift to your friend.',
    giftIdLabel: 'Gift ID: ',
    logoAlt: 'Naegift',
    serviceIntro: 'Service introduction',
    storeSupport: 'Store support',
    logout: 'Logout',
    myPage: 'My page',
    login: 'Login',
    signup: 'Sign up',
    defaultNickname: 'Guest',
    numbersOnly: 'Please enter numbers only.',
    validEmailRequired: 'Please enter a valid email address.',
    phoneRequired: 'Please enter phone number.',
    emailRequired: 'Please enter email.',
    selectRequired: 'Selection required',
    selectReceiveMethod: 'Please select how to receive the gift.',
    inputRequired: 'Input required',
    giftNoteRequired: 'Please enter gift message.',
    purchaseUnavailable: 'This gift is currently unavailable for purchase.',
    purchaseBlocked: 'Purchase unavailable',
    testGift: 'Test gift',
    giftDisabled: 'This gift has been disabled',
    paymentLoadFailed: 'Failed to load payment information.',
    amountMismatch: 'Payment amount does not match.',
    paymentCheckError: 'An error occurred while verifying payment.',
    paymentApprovalError: 'An error occurred during payment approval.',
    copyToClipboard: 'Copied to clipboard',
    allStoreGifts: 'All store gifts',
    allStoreGiftsDesc: 'Browse gifts from all stores in one place.',
    searchHint:
      'Ask in plain language and AI will find gifts. (e.g. cafes in Incheon)',
    searchHintKeyword:
      'Search by store name, gift name, or area / address keywords.',
    searchPlaceholder: 'Find me cafes in Incheon',
    searchPlaceholderKeyword: 'e.g. Starbucks, americano, Incheon',
    marketSearchModeAi: 'AI search',
    marketSearchModeKeyword: 'Keyword',
    marketChannelAll: 'All',
    marketChannelFilter: 'Channel',
    marketChannelMore: 'More',
    marketChannelFold: 'Fold',
    searchLabel: 'Search',
    searching: 'Searching...',
    noSearchResult: 'No search results.',
    noGiftsToShow: 'No gifts to display.',
    emptyUnusedGifts: 'No unused gifts',
    emptyUnavailableGifts: 'No unavailable gifts',
    emptyReceivedGifts: 'No received gifts',
    emptyPurchaseHistory: 'No purchase history',
    emptyUnusedPurchaseHistory: 'No unused purchases',
    emptyUnavailablePurchaseHistory: 'No unavailable purchases',
    noProductsYet: 'Preparing gifts.',
    productsComingSoon: 'Coming soon.',
    noStoreInfo: 'No store info',
    marketStoreLocation: 'Location',
    marketStoreLocationMissing:
      'No location on file. Check the store page for directions.',
    marketViewStore: 'Store home',
    marketStoreAddress: 'Address: ',
    marketOpenMap: 'Map',
    giftImageAlt: 'Gift image',
    noDescription: 'No description',
    loadMore: 'Loading more...',
    maxBenefitPrice: 'Best price',
    allGiftsLoaded: 'All gifts loaded.',
    bank: 'Bank',
    accountNo: 'Account number',
    accountHolder: 'Account holder',
    applicantName: 'Name',
    applicantPhone: 'Phone number',
    refundReason: 'Refund reason',
    cancel: 'Cancel',
    refundSubmit: 'Submit refund',
    refundCancelNotice: 'Gift will be cancelled when refund is requested.',
    refundFeeNotice: 'Refund amount excludes a 10% refund fee.',
    selectBank: 'Please select a bank.',
    bankSelectOption: 'Select bank',
    accountNoRequired: 'Please enter your account number.',
    accountHolderRequired: 'Please enter the account holder name.',
    accountNoPlaceholder: 'Enter account number',
    accountHolderPlaceholder: 'Enter account holder name',
    accountHolderAutoPlaceholder: 'Filled in automatically from the name',
    applicantNameRequired: 'Please enter your name.',
    applicantPhoneRequired: 'Please enter your phone number.',
    applicantNamePlaceholder: 'Enter name',
    applicantPhonePlaceholder: 'Enter phone number',
    refundReasonPlaceholder: 'Enter refund reason',
    refundSubmitted: 'Refund request has been submitted.',
    refundFailed: 'Refund request failed.',
    refundCannotReceive:
      'Refund unavailable because recipient has already received the gift.',
    scanUnavailable: 'Scan unavailable',
    viewQr: 'View QR',
    qrModalTitle: 'QR Code',
    qrModalClose: 'Close',
    qrEntryChoiceMessage: 'What would you like to do?',
    qrEntryGoStore: 'Send a gift',
    qrEntryVerify: 'Use a gift',
    qrEntryStoreInfo: 'About this store',
    qrEntryStoreTitleSuffix: 'Gifts',
    verifyGuideCoachText: 'Tap this button to verify your gift',
    verifyGuideCoachShowToOwner:
      'Show the verification success screen to the store owner',
    verifyGuideCoachDismiss: 'Tap anywhere to close',
    validityExpired: 'Validity expired',
    usedOrRefunded: 'Used or refunded',
    used: 'Used',
    confirmRefundMessage:
      'Refund cannot be cancelled once requested.\nDo you want to proceed?',
    refundRequest: 'Request Refund',
    refundRequested: 'Refund Requested',
    refundComplete: 'Refund Completed',
    refundFailedStamp: 'Refund Failed',
    storeClosedRefundNotice: 'This store has closed and can no longer be used. Please request a refund.',
    requestReprocess: 'Request Reprocess',
    requestReprocessLoading: 'Requesting...',
    requestReprocessConfirm:
      'Payment was completed but purchase registration failed.\nDo you want to request reprocessing?',
    requestReprocessSuccess:
      'Reprocess request submitted. Our team will review and process it.',
    requestReprocessFailed:
      'Reprocess request failed. It may already be requested or payment status is invalid.',
    requestReprocessAlready: 'Reprocess already requested.',
    extendValidityAction: 'Extend validity by 3 months',
    extendValidityLoading: 'Extending...',
    extendValidityConfirm:
      'Do you want to extend the validity by 3 months?\n(Maximum validity is 1 year from initial payment date.)',
    extendValiditySuccess: 'Validity has been extended.',
    extendValidityFailed:
      'Failed to extend validity. Check expiry/refund status or max extension limit (1 year).',
    notReceived: 'Not received',
    loading: 'Loading...',
    alreadyReceived: 'You have already received this gift',
    checkReceivedGifts: 'You can check the gift in your received gifts.',
    goToReceived: 'Go to received gifts',
    selfGiftPurchaseComplete: 'Purchase complete.',
    claimGift: 'Receive gift',
    dataLoadError: 'An error occurred while loading data.',
    giftNotPurchasable: 'This gift is not available for purchase right now.',
    giftAmountLabel: 'Gift amount',
    paymentInfoTitle: 'Payment details',
    totalDiscountLabel: 'Total discount',
    paidAmountLabel: 'Amount paid',
    discountAppliedSuffix: 'discount applied',
    paymentMethodTitle: 'Payment method',
    paymentCanceled:
      'Payment was cancelled. Please select another payment method.',
    tryAgain: 'Please try again later.',
    paymentRequestFailed:
      'Payment request failed. Please refresh and try again.',
    paymentParamMissing:
      'Payment confirmation data was lost. Please try again.',
    loginRequired: 'Login required',
    loginRequiredText: 'Please log in to continue.',
    confirmButton: 'Confirm',
    goToMarket: 'Go to Market',
    storeLabel: 'Store',
    toNameSuffix: '',
    toNamePrefix: 'To ',
    bizNumLabel: 'Business no.',
    repLabel: 'Representative',
    addressLabel: 'Address',
    roadAddressLabel: 'Road name address',
    jibunAddressLabel: 'Lot number (jibun) address',
    storeNameLabel: 'Business name',
    operationHoursLabel: 'Customer service hours',
    phoneLabel: 'Phone',
    serviceTerms: 'Terms of Service',
    privacyPolicy: 'Privacy Policy',
    defaultRepresentative: 'Koseunggon',
    defaultCompanyName: 'Authrium Co., Ltd.',
    defaultOperationHours: 'Mon-Fri 09:00 - 18:00',
    defaultOperationHoursNote:
      '(Closed 12:00-13:00 for lunch / Closed weekends and holidays)',
    giftListLoadFailed: 'Failed to load gift list.',
    searchError: 'An error occurred while searching.',
    myInfoTitle: 'My Info',
    naverAuthProcessing: 'Processing Naver authentication...',
    allAgree: 'Agree to all',
    kakaoLogin: 'Kakao Login',
    naverLogin: 'Naver Login',
    googleLogin: 'Google Login',
    appleLogin: 'Apple Login',
    globalLoginTitle: 'All stores integrated login',
    globalLoginDesc: 'Sign in once to use all store services.',
    backToAllStores: 'Back to all stores',
    male: 'Male',
    female: 'Female',
    withdrawButton: 'Withdraw',
    // [APP-FORK] 앱 탈퇴(soft delete) — store_user·선물 이력을 지우는 상점 탈퇴와 별개.
    withdrawApp: 'Withdraw from app',
    withdrawAppModal:
      'Withdrawing from the app signs you out and revokes your consent to the terms. Withdraw?',
    withdrawCondition:
      'For this store: sending side — only unreceived gifts (GS000) block you; after the recipient claims, their unused voucher does not block you as the sender. Received gifts — unused (GS001) blocks withdrawal until fully refunded; you can leave only after use complete, already-used error (GS003), or refund complete (PS024). Expiry/validity error (GS004) also blocks until resolved. Other stores stay unchanged.',
    withdrawFromStore: 'Leave this store',
    withdrawNeedStoreContext:
      'Store context is missing. Open My Info from a store page and try again.',
    withdrawModalStep1:
      'If you leave this store, unused and unclaimed gift vouchers here will be forfeited and cannot be restored. Other stores are not affected. Continue?',
    withdrawModalStep2:
      'If you join this store again later, your past sent and received gift history for this store will not appear in the app. Proceed with withdrawal?',
    withdrawSuccessTitle: 'You have left the store',
    withdrawSuccessMessage:
      'Your membership at this store has ended and you have been signed out.',
    processing: 'Processing...',
    // 마켓홈 공지 팝업 (components/common/NoticePopup.tsx)
    noticeRequiredLabel: 'Required notice',
    noticeAgree: 'Agree',
    noticeDisagree: 'Do not agree',
    noticeConfirm: 'Confirm',
    noticeClose: 'Close',
    noticeConsentFailed: 'Failed to record your consent. Please try again.',
    noticeScrollToEnd: 'Please read to the end before agreeing.',
    noticeHideToday: "Don't show today",
    // 약관 관문 팝업 (components/common/TermsPopup.tsx)
    termsPopupTitle: 'Naegift Terms and Conditions',
    termsServiceLabel: '(Required) Terms of service',
    termsPrivacyLabel: '(Required) Collection and use of personal data',
    termsMarketingLabel: '(Optional) Marketing communications',
    termsMarketingDesc:
      'Receive tailored marketing information such as events, discounts, and new product announcements. Declining does not limit your use of the service.',
    termsView: 'View',
    termsSaveFailed: 'Failed to save your consent. Please try again.',
    // 내 정보 알림 설정
    notificationSection: 'Notification settings',
    marketingConsentLabel: 'Marketing communications',
    marketingConsentStoreNameLabel: 'Marketing communications from {store}',
    marketingConsentStoreLabel: 'Marketing communications from this store',
    toggleLanguageKo: 'EN',
    toggleLanguageEn: '한글',
  },
};

export default translations;
